//
//  SDKFrameAlignment.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var FrameAlignment;
(function (FrameAlignment) {
    FrameAlignment["frameHeight"] = "FrameHeight";
    FrameAlignment["center"] = "Center";
})(FrameAlignment || (FrameAlignment = {}));
